import Link from '@/ui/Link';
import Button from '@/ui/Button';
import Image from '@/ui/Image';
import SearchMovies from '@/features/SearchMovies';
import logo from '@/assets/img/header/logotip.webp';
import IconUser from '@/assets/img/header/user.svg';
import IconGenre from '@/assets/img/header/genres.svg';
// Стили
import './Header.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var navLinks = [{
        id: 1,
        name: 'Главная',
        to: '/main'
    }, {
        id: 2,
        name: 'Жанры',
        to: '/genres'
    }];
var Header = function Header(_ref) {
    var user = _ref.user, loading = _ref.loading, isAuth = _ref.isAuth, onLoginClick = _ref.onLoginClick;
    var showUser = !!user && isAuth;
    return /*#__PURE__*/ _jsx("header", {
        className: "header",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "header__wrapper",
                children: [/*#__PURE__*/ _jsx(Link, {
                        to: "/main",
                        variant: "logo",
                        "aria-label": "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E",
                        className: "header__logo-link",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: logo,
                            alt: "logo",
                            width: 144,
                            height: 32,
                            className: "header__logo",
                            loading: "eager"
                        })
                    }), /*#__PURE__*/ _jsxs("nav", {
                        className: "header__nav",
                        children: [/*#__PURE__*/ _jsxs("ul", {
                                className: "header__nav-list",
                                children: [/*#__PURE__*/ _jsx("li", {
                                        className: "header__nav-item header__nav-item--sm",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            to: "/genres",
                                            variant: "default",
                                            children: /*#__PURE__*/ _jsx(IconGenre, {})
                                        })
                                    }), navLinks.map(function (link) {
                                        return /*#__PURE__*/ _jsx("li", {
                                            className: "header__nav-item",
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                to: link.to,
                                                label: link.name
                                            })
                                        }, link.id);
                                    })]
                            }), /*#__PURE__*/ _jsx(SearchMovies, {})]
                    }), showUser ? /*#__PURE__*/ _jsxs(Link, {
                        to: "/account",
                        className: "header__user",
                        "aria-label": "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
                        children: [/*#__PURE__*/ _jsx("span", {
                                className: "header__user-text",
                                children: user.name
                            }), /*#__PURE__*/ _jsx("span", {
                                className: "header__user-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx(IconUser, {})
                            })]
                    }) : !loading && /*#__PURE__*/ _jsxs(Button, {
                        variant: "ghost",
                        className: "header__login",
                        onClick: onLoginClick,
                        "aria-label": "\u0412\u043E\u0439\u0442\u0438",
                        children: [/*#__PURE__*/ _jsx("span", {
                                className: "header__user-text",
                                children: "\u0412\u043E\u0439\u0442\u0438"
                            }), /*#__PURE__*/ _jsx("span", {
                                className: "header__user-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx(IconUser, {})
                            })]
                    })]
            })
        })
    });
};
export default Header;
